import { Form, Input, Row, Col, Switch, InputNumber, AutoComplete, Select, DatePicker } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';
import getList from '../../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const { defaultService } = props;
    const [form] = Form.useForm();
    const apiId = 'membershipPhysicalCard';
    const ref = useRef<any>(undefined);

    const [membershipData, setMembershipData] = useState<any[]>([]);
    const [verificationMethodData, setVerificationMethodData] = useState<any>();
    const [membershipStatusData, setMembershipStatusData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'membership',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setMembershipData(res.data);
            }
        });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'verificationMethod@membershipStatus',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { verificationMethod, membershipStatus } = res.data;
                    setVerificationMethodData(verificationMethod);
                    setMembershipStatusData(membershipStatus);
                }
            })
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'business',
        displayOptions: {
            width: 700
        },
        dateOptions: {
            columnNames: ['bindDate', 'expireDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="实体卡id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="会员"
                            name="membershipId">
                            <Select
                                placeholder="会员"
                                disabled={true}
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipData, {
                                    includeNull: true,
                                    setItemNameFun: (item: any) => {
                                        const { id, membershipInfo } = item;
                                        return {
                                            id,
                                            name: `${id}【${membershipInfo?.membershipName}】`
                                        }
                                    }
                                })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="绑定日期"
                            name="bindDate">
                            <DatePicker
                                disabled={true}
                                format="YYYY-MM-DD"
                                style={{ width: 140 }} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="有效期"
                            name="expireDate">
                            <DatePicker
                                format="YYYY-MM-DD"
                                style={{ width: 140 }} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="验证方法"
                            name="verificationMethodId">
                            <Select
                                placeholder="验证方法"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(verificationMethodData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="卡状态"
                            name="cardStatusId">
                            <Select
                                placeholder="卡状态"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(membershipStatusData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="密码"
                            name="password">
                            <Input.Password />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            <Switch
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="备注"
                            name="memo">
                            <Input.TextArea
                                rows={1}
                            />
                        </Form.Item>
                    </Col>
                </Row>


            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;